import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';

import { PageSkeleton } from '~/components/common/page-skeleton/page-skeleton';

const QualityReportScreen = lazy(() => import('~/features/item-setup/pages/quality-report-screen'));

export const Route = createFileRoute('/_authenticated/_tenant/item-setup/quality-report')({
  component: () => (
    <Suspense fallback={<PageSkeleton />}>
      <QualityReportScreen />
    </Suspense>
  ),
});
